import { useContext } from "react";
import { DomainContext } from "../provider/domain.provider";

const useDomain = () => {
  let { data } = useContext(DomainContext);
  if (!data) return {};
  return { ...data };
};

export default useDomain;
